// Version : 0.0.3
// Author : VIGNESH
// LastEdit: VIGNESH
// MODFIED DATE : 07-12-2025
// LAST MOFIFIED: ADDED COMMENTS AND REMOVED UNWANTED REDUX

import GoldloanInterestReminderReportTypes from './gold-loan-interest-reminder-report.types';

/** ***************** FETCH GOLD LOAN INTEREST REMINDER DETAILS START *********************** */
export const getGoldLoanInterestReminderStart = (fetchData: any) => ({
	type: GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_START,
	payload: fetchData,
});

export const getGoldLoanInterestReminderSucess = (successData: any) => ({
	type: GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_SUCCESS,
	payload: successData,
});

export const getGoldLoanInterestReminderFailure = (failureData: any) => ({
	type: GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_FAILURE,
	payload: failureData,
});

export const getGoldLoanInterestReminderResponseReset = () => ({
	type: GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_RESPONSE_RESET,
});

export const getGoldLoanInterestReminderResponseChanged = () => ({
	type: GoldloanInterestReminderReportTypes.GET_GOLD_LOAN_INTEREST_REMINDER_REPORT_RESPONSE_CHANGED,
});

/** ***************** FETCH GOLD LOAN INTEREST REMINDER DETAILS END *********************** */
